/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarsSort: {
  name: 'bars-sort';
  data: string;
} = {
  name: 'bars-sort',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H4Z" fill="currentColor"/></svg>`,
};
